type UserRole = "super_admin" | "admin" | "user" | null;

const ROLE_MODULE_MAP: Record<string, { path: string; label: string }> = {
  super_admin: { path: "/admin", label: "Administração" },
  admin: { path: "/admin", label: "Administração" },
};

const MODULE_KEY_PATH_MAP: Record<string, string> = {
  admin: "/admin",
  catalog: "/catalogo",
  crm: "/crm",
  "assistencia-tecnica": "/assistencia-tecnica",
  armazem: "/armazem",
  contabilidade: "/contabilidade",
  burocracia: "/burocracia",
  procurement: "/procurement",
};

const MODULE_KEY_LABEL_MAP: Record<string, string> = {
  admin: "Administração",
  catalog: "Catálogo",
  crm: "CRM",
  "assistencia-tecnica": "Assistência Técnica",
  armazem: "Armazém",
  contabilidade: "Contabilidade",
  burocracia: "Burocracia",
  procurement: "Compras",
};

export function isInternalRole(role: UserRole): boolean {
  return role === "super_admin" || role === "admin";
}

export function getModuleForRole(role: UserRole): { path: string; label: string } | null {
  if (!role) return null;
  return ROLE_MODULE_MAP[role] || null;
}

export function getModulePath(moduleKey: string | null | undefined): string | null {
  if (!moduleKey) return null;
  return MODULE_KEY_PATH_MAP[moduleKey] || null;
}

export function getModuleLabel(moduleKey: string | null | undefined): string | null {
  if (!moduleKey) return null;
  return MODULE_KEY_LABEL_MAP[moduleKey] || null;
}

/**
 * Resolves effective "internal" status for a user. A user is internal if they
 * have an admin role OR any module permission (warehouse, crm, accounting...).
 * Returns the best module info to surface in the user menu.
 */
export function resolveEffectiveModule(
  role: UserRole,
  modulePermissions: string[],
  preferredModule?: string | null
): { isInternal: boolean; path: string; label: string } | null {
  const roleModule = getModuleForRole(role);
  if (roleModule) return { isInternal: true, ...roleModule };

  // Prefer the user's preferred module if they actually have it
  const candidate =
    (preferredModule && modulePermissions.includes(preferredModule) ? preferredModule : null) ||
    modulePermissions[0];

  if (!candidate) return null;
  const path = getModulePath(candidate);
  const label = getModuleLabel(candidate);
  if (!path || !label) return null;
  return { isInternal: true, path, label };
}
